import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Style Guide", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This page provides an overview of the style guide based on the Component Library created by the XD team. This project is based on Vue 3 and the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://vuetifyjs.com/en/",
    target: "_blank"
  }, "Vuetify Component Framework"),
  /*#__PURE__*/_createTextVNode(". The Vuetify base styles have been overridden utilizing Sass to match the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.figma.com/design/dwePPWv7hJ4RjB2oyoFVwN/EchoPark-Design-System-2.0?node-id=155-7598&t=2RtiXbZET3I1pf02-0",
    target: "_blank"
  }, "Figma"),
  /*#__PURE__*/_createTextVNode(" provided by the XD team. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Sass Files", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createTextVNode(" This project utilized Sass to write and compile CSS more efficiently and effectively. The Sass files can be found at "),
  /*#__PURE__*/_createElementVNode("code", null, "/src/Project/EchoPark/client/src/assets/styles")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub-head" }, "main.scss"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This is the main Sass file where other Sass files are included. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub-head" }, "settings.scss"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This file contains explicit overrides to the default Vuetify Sass variables ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub-head" }, "_variables.scss"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This file contains Sass variables that define Echo Park styles ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub-head" }, "legacy.scss"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This file contains legacy CSS from the original codebase. As components are created in the Vue 3 codebase, be sure to remove unnecessary and unused rules from this file so we're lean and clean. ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub-head" }, "global.scss"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This file contains new global styling rules specific to the new Vue 3 codebase. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sub-head" }, "Other Sass Partials"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" When creating reusable component styles, use Sass partials so it's not generated into CSS unless it's included in another Sass file. If you want to include a partial in another "),
  /*#__PURE__*/_createElementVNode("code", null, "*.scss"),
  /*#__PURE__*/_createTextVNode(" file, include it like"),
  /*#__PURE__*/_createElementVNode("code", null, "@use 'buttons'"),
  /*#__PURE__*/_createTextVNode(" (be sure the path is correct). If you want to include a partial in a "),
  /*#__PURE__*/_createElementVNode("code", null, "*.vue"),
  /*#__PURE__*/_createTextVNode(" file, include it like"),
  /*#__PURE__*/_createElementVNode("code", null, "@use '@/assets/styles/variables' as *;"),
  /*#__PURE__*/_createTextVNode(" (again, making sure the path is correct). Adding the "),
  /*#__PURE__*/_createElementVNode("code", null, "as *"),
  /*#__PURE__*/_createTextVNode(" will allow you to not need to use the variables like "),
  /*#__PURE__*/_createElementVNode("code", null, "color: variables.$park-gray-0;")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Sections", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#border-radius" }, "Border Radius")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#border-width" }, "Border Width")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#breakpoints" }, "Breakpoints")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#buttons" }, "Buttons")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#colors" }, "Colors")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#forms-and-inputs" }, "Forms & Inputs")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#opacity-levels" }, "Opacity Levels")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#shadows" }, "Shadows")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#spacing-horizontal" }, "Spacing [Horizontal]")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#spacing-inset" }, "Spacing [Inset]")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#spacing-vertical" }, "Spacing [Vertical]")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#tooltips" }, "Tooltips")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#typography" }, "Typography")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_StyleGuideBorderRadius = _resolveComponent("StyleGuideBorderRadius")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_StyleGuideBorderWidth = _resolveComponent("StyleGuideBorderWidth")!
  const _component_StyleGuideBreakpoints = _resolveComponent("StyleGuideBreakpoints")!
  const _component_StyleGuideButtons = _resolveComponent("StyleGuideButtons")!
  const _component_StyleGuideColors = _resolveComponent("StyleGuideColors")!
  const _component_StyleGuideFormsAndInputs = _resolveComponent("StyleGuideFormsAndInputs")!
  const _component_StyleGuideOpacityLevels = _resolveComponent("StyleGuideOpacityLevels")!
  const _component_StyleGuideShadows = _resolveComponent("StyleGuideShadows")!
  const _component_StyleGuideSpacingHorizontal = _resolveComponent("StyleGuideSpacingHorizontal")!
  const _component_StyleGuideSpacingInset = _resolveComponent("StyleGuideSpacingInset")!
  const _component_StyleGuideSpacingVertical = _resolveComponent("StyleGuideSpacingVertical")!
  const _component_StyleGuideTooltips = _resolveComponent("StyleGuideTooltips")!
  const _component_StyleGuideTypography = _resolveComponent("StyleGuideTypography")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "style-guide" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "overview" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_expansion_panels, { multiple: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, { id: "border-radius" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Border Radius ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideBorderRadius)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "border-width" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Border Width ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideBorderWidth)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "breakpoints" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Breakpoints ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideBreakpoints)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "buttons" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Buttons ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideButtons)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "colors" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Colors ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideColors)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "forms-and-inputs" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Forms & Inputs ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideFormsAndInputs)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "opacity-levels" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Opacity Levels ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideOpacityLevels)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "shadows" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Shadows ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideShadows)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "spacing-horizontal" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Spacing [Horizontal] ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideSpacingHorizontal)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "spacing-inset" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Spacing [Inset] ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideSpacingInset)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "spacing-vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Spacing [Vertical] ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideSpacingVertical)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "tooltips" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Tooltips ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideTooltips)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expansion_panel, { id: "typography" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, {
                "collapse-icon": "mdi-minus",
                "expand-icon": "mdi-plus"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Typography ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_StyleGuideTypography)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}